import { gql, useMutation } from '@apollo/client';
import { UserAuthContext } from 'contexts/UserAuthContext';
import { ERROR_TYPE, TTError, handleException } from 'models/ErrorHandling';
import { enqueueSnackbar } from 'notistack';
import { useContext } from 'react';

const SAVE_GQL = gql`
    mutation CreateLesson {
        createLesson(data: {}) {
            id
            latestLessonDraft {
                id
            }
        }
    }
`;

type MutationVariableType = {
    lessonName: string;
};

type MutationType = {
    createLesson: {
        id: string;
        latestLessonDraft: {
            id: string;
        };
    };
};

export const useLessonCreateMutation = () => {
    const { accessDenied } = useContext(UserAuthContext);
    const [saveForm] = useMutation<MutationType>(SAVE_GQL);

    const createLesson = async (variables: MutationVariableType) => {
        try {
            const result = await saveForm({
                variables,
            });

            if (!result || !result.data?.createLesson) {
                throw new TTError(ERROR_TYPE.UPDATE_FAILED);
            }

            return result.data;
        } catch (err) {
            const errMessage = handleException(err);
            if (errMessage === ERROR_TYPE.KS_ACCESS_DENIED) {
                accessDenied(errMessage);
            } else {
                enqueueSnackbar(errMessage, {
                    variant: 'error',
                    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                });
            }
            throw new TTError();
        }
    };

    return { createLesson };
};
